import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    menuLabel: string;
    placeholder: string;
    searchPlaceholder: string;
    noSearchResults: string;
    noPermissions: string;
    clearButtonAriaLabel: string;
    pendingStateLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu label for the workspace selector */
            menuLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceSelect.menuLabel?c=2qdcenpfm5ojs", defaultMessage: "Workspaces" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Placeholder text when no workspace is selected */
            placeholder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceSelect.placeholder?c=16ar8qk6pmb9o", defaultMessage: "Select Workspace" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Search input placeholder for filtering workspaces */
            searchPlaceholder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceSelect.searchPlaceholder?c=3urfhu5j4omas", defaultMessage: "Search" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Empty state message when no search results match */
            noSearchResults: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceSelect.noSearchResults?c=2fq1qdb9cujh5", defaultMessage: "No results match your current search criteria." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message shown when user lacks project creation permission */
            noPermissions: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceSelect.noPermissions?c=oyrhz28p5ber", defaultMessage: "You can''t create projects because you don''t have permission. Contact your admin for help." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for the clear search button */
            clearButtonAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceSelect.clearButtonAriaLabel?c=3e92inhv1e2pm", defaultMessage: "Clear search input" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Pending state label shown while searching */
            pendingStateLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceSelect.pendingStateLabel?c=2xzqohvscs9ht", defaultMessage: "Searching" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
